import styles from './PublicPage.module.scss'

const EventImage = ({ url }) => (
  <div className={styles.eventImage}>
    {url && <img src={url} alt="event" />}
  </div>
)

export default EventImage
